import { Vortex as defaultOptions } from "./defaultOptionsForComputation";

export default function () {
  let options = defaultOptions;

  function calculator(data) {
    const { period } = options;

    // Result array with same length as input
    const results = [];

    // Arrays to track values for sliding window
    const trueRangeWindow = [];
    const vmPlusWindow = [];
    const vmMinusWindow = [];

    // Running sums
    let trueRangeSum = 0;
    let vmPlusSum = 0;
    let vmMinusSum = 0;

    for (let i = 0; i < data.length; i++) {
      const current = data[i];

      // Need at least 2 bars to calculate
      if (
        i === 0 ||
        !current ||
        current.high === undefined ||
        current.low === undefined ||
        current.close === undefined
      ) {
        results.push(undefined);
        continue;
      }

      const previous = data[i - 1];
      if (
        !previous ||
        previous.high === undefined ||
        previous.low === undefined ||
        previous.close === undefined
      ) {
        results.push(undefined);
        continue;
      }

      // Calculate vortex movements
      // vmPlus = |High[i] - Low[i-1]|
      const vmPlus = Math.abs(current.high - previous.low);

      // vmMinus = |Low[i] - High[i-1]|
      const vmMinus = Math.abs(current.low - previous.high);

      // True Range = max(High[i], Close[i-1]) - min(Low[i], Close[i-1])
      const trueRange =
        Math.max(current.high, previous.close) -
        Math.min(current.low, previous.close);

      // Add to windows
      trueRangeWindow.push(trueRange);
      vmPlusWindow.push(vmPlus);
      vmMinusWindow.push(vmMinus);

      // Add to sums
      trueRangeSum += trueRange;
      vmPlusSum += vmPlus;
      vmMinusSum += vmMinus;

      // Remove oldest values if window exceeds period
      if (trueRangeWindow.length > period) {
        trueRangeSum -= trueRangeWindow.shift();
        vmPlusSum -= vmPlusWindow.shift();
        vmMinusSum -= vmMinusWindow.shift();
      }

      // Calculate VI values only when we have enough data
      if (trueRangeWindow.length >= period && trueRangeSum !== 0) {
        const plusVI = vmPlusSum / trueRangeSum;
        const minusVI = vmMinusSum / trueRangeSum;

        results.push({
          plusVI,
          minusVI,
        });
      } else {
        results.push(undefined);
      }
    }

    return results;
  }

  calculator.undefinedLength = function () {
    return options.period; // Need 'period' bars before first result
  };

  calculator.options = function (x) {
    if (!arguments.length) {
      return options;
    }
    options = { ...defaultOptions, ...x };
    return calculator;
  };

  return calculator;
}
